import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../NavigationContainer.vue";
import { store } from "@/store/store";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const DEST = ref("");
const isOpen = ref(false);
const newUrl = ref("");

const linkToOtherWindow = () => {
  newUrl.value =
    "https://scanh.bizapps.suzuki/main/TO_V2.asp?DEST=" +
    DEST.value +
    "&CTLNO=" +
    store.getters.loginNumber;
  window.open(newUrl.value, "_blank");
};
const makeUrl = () => {
  isOpen.value = false;
  newUrl.value =
    "https://scanh.bizapps.suzuki/main/TO_V2.asp?DEST=" +
    DEST.value +
    "&CTLNO=" +
    store.getters.loginNumber;
  isOpen.value = true;
};
const openSRDB = () => {
  newUrl.value =
    "https://scanh.bizapps.suzuki/main/TO_V2.asp?DEST=" +
    DEST.value +
    "&CTLNO=" +
    store.getters.loginNumber;
  window.open(newUrl.value, "testwindow", "width=1000, height=500");
};

const __returned__ = { DEST, isOpen, newUrl, linkToOtherWindow, makeUrl, openSRDB, Navigation, store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})